import { type ChatUserAttributes } from './chat-user-attributes';

/** Chat user. */
export type ChatUser = Readonly<{

  /** Id. */
  id: string;

  /** First name. */
  firstName: string | null;

  /** Last name. */
  lastName: string | null;
}>;

/**
 * Transform twilio conversation user to chat user domain model.
 * @param data Conversation user attributes.
 */
export function fromChatUserAttributes(data: ChatUserAttributes): ChatUser {
  return {
    firstName: data.first_name ?? '',
    lastName: data.last_name ?? '',
    id: data.id.toString(),
  };
}
